'use client';

import { LoginButton } from '@/components/login-button';
import { TelegramAuthData } from '@/components/login-button/types';
import { useEffect, useState, type ReactElement } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { LoadingSpinner } from '@/components/ui/loading-spinner';

export default function Auth(): ReactElement {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const [location, setLocation] = useState<string | null>(null);

  useEffect(
    () => setLocation(`${window.location.origin}${pathname}?${searchParams.toString()}`),
    [pathname, searchParams],
  );

  const onAuthCallback = (data: TelegramAuthData) => {
    const queryParams = new URLSearchParams();
    Object.entries(data).forEach(([key, value]) => queryParams.append(key, String(value)));
    searchParams.forEach((value, key) => queryParams.append(key, String(value)));
    router.push(`/auth/callback?${queryParams.toString()}`);
  };

  return (
    <div className="w-fit flex flex-col gap-4 items-center justify-center">
      {location ? (
        <div className="hidden sm:flex w-fit items-center justify-center border rounded-lg bg-secondary p-2">
          <div className="w-fit h-fit bg-white rounded-lg p-4">
            <QRCodeSVG className="w-40 h-40 sm:w-56 sm:h-56 md:w-80 md:h-80" value={location} />
          </div>
        </div>
      ) : (
        <LoadingSpinner />
      )}
      <div className="w-fit flex items-center justify-center">
        <LoginButton
          botUsername={String(process.env.NEXT_PUBLIC_BOT)}
          requestAccess="write"
          cornerRadius={8}
          buttonSize="large"
          onAuthCallback={onAuthCallback}
        />
      </div>
    </div>
  );
}
